export const kategorien = [
    {
        oberKatLabel: "Werkzeuge",
        backendColor: "#a72716",
        color: "white",
        unterKat: [
            {
                label: "Handwerkzeug",
                value: "Handwerkzeug",
            },
            {
                label: "Gartengeräte",
                value: "Gartengeräte",
            },
            {
                label: "Elektrowerkzeuge / Power-Tools",
                value: "Elektrowerkzeuge / Power-Tools",
            },
            {
                label: "Trennende Werkzeuge",
                value: "Trennende Werkzeuge",
            },
            {
                label: "Maschinenmesser",
                value: "Maschinenmesser",
            },
            {
                label: "Kreismesser",
                value: "Kreismesser",
            },
            {
                label: "Spanende Werkzeuge",
                value: "Spanende Werkzeuge",
            },
            {
                label: "Fräsen",
                value: "Fräsen",
            },
            {
                label: "Bohren",
                value: "Bohren",
            },
            {
                label: "Schleifen",
                value: "Schleifen",
            },
            {
                label: "Gewindeschneiden",
                value: "Gewindeschneiden",
            },
        ],
    },
    {
        oberKatLabel: "Schneidwaren",
        backendColor: "#ccc",
        color: "black",
        unterKat: [
            {
                label: "Bestecke",
                value: "Bestecke",
            },
            {
                label: "Scheren",
                value: "Scheren",
            },
            {
                label: "Klingen",
                value: "Klingen",
            },
            {
                label: "Tafelhilfsgeräte",
                value: "Tafelhilfsgeräte",
            },
            {
                label: "Kochutensilien",
                value: "Kochutensilien",
            },
            {
                label: "Rasiermesser, Rasierklingen und Rasierapparate",
                value: "Rasiermesser, Rasierklingen und Rasierapparate",
            },
        ],
    },
    {
        oberKatLabel: "Maschinenbau",
        backendColor: "#ccc",
        color: "black",
        unterKat: [
            {
                label: "Mechatronik",
                value: "Mechatronik",
            },
            {
                label: "Automation",
                value: "Automation",
            },
            {
                label: "Automatisierungstechnik",
                value: "Automatisierungstechnik",
            },
            {
                label: "Elektronikentwicklung",
                value: "Elektronikentwicklung",
            },
        ],
    },
    {
        oberKatLabel: "Automotive",
        backendColor: "#ccc",
        color: "black",
        unterKat: [],
    },
    {
        oberKatLabel: "Schloss- und Beschlagindustrie",
        backendColor: "#ccc",
        color: "black",
        unterKat: [],
    },
    {
        oberKatLabel: "Draht- und Kabelindustrie",
        backendColor: "#ccc",
        color: "black",
        unterKat: [],
    },
    {
        oberKatLabel: "Messsysteme",
        backendColor: "#ccc",
        color: "black",
        unterKat: [],
    },
    {
        oberKatLabel: "Dienstleistungen",
        backendColor: "#ccc",
        color: "black",
        unterKat: [],
    },
    {
        oberKatLabel: "Digitalisierung",
        backendColor: "#ccc",
        color: "black",
        unterKat: [
            {
                label: "Künstliche Intelligenz",
                value: "Künstliche Intelligenz",
            },
            {
                label: "Robotik",
                value: "Robotik",
            },
            {
                label: "Augmented Reality",
                value: "Augmented Reality",
            },
            {
                label: "CAD / CAE",
                value: "CAD / CAE",
            },
            {
                label: "Produktionstechnologien",
                value: "Produktionstechnologien",
            },
            {
                label: "Softwareentwicklung",
                value: "Softwareentwicklung",
            },
        ],
    },
    {
        oberKatLabel: "Verfahrenstechnik",
        backendColor: "#ccc",
        color: "black",
        unterKat: [
            {
                label: "Umformtechnik",
                value: "Umformtechnik",
            },
            {
                label: "Massivumformung ",
                value: "Massivumformung ",
            },
            {
                label: "Gesenkschmieden",
                value: "Gesenkschmieden",
            },
            {
                label: "Fließpressen",
                value: "Fließpressen",
            },
            {
                label: "Freiformschmieden ",
                value: "Freiformschmieden ",
            },
            {
                label: "Strangpressen",
                value: "Strangpressen",
            },
            {
                label: "Blechumformung ",
                value: "Blechumformung ",
            },
            {
                label: "Scherschneiden",
                value: "Scherschneiden",
            },
            {
                label: "Tiefziehen",
                value: "Tiefziehen",
            },
            {
                label: "Biegen",
                value: "Biegen",
            },
            {
                label: "Wärmebehandlung",
                value: "Wärmebehandlung",
            },
            {
                label: "Oberflächentechnik",
                value: "Oberflächentechnik",
            },
            {
                label: "Galvanotechnik",
                value: "Galvanotechnik",
            },
            {
                label: "3D-Druck (Additive Fertigung)",
                value: "3D-Druck (Additive Fertigung)",
            },
            {
                label: "Optische Technologien",
                value: "Optische Technologien",
            },
            {
                label: "Lasertechnik",
                value: "Lasertechnik",
            },
            {
                label: "Urformen",
                value: "Urformen",
            },
            {
                label: "Gießen",
                value: "Gießen",
            },
            {
                label: "Fügeverfahren",
                value: "Fügeverfahren",
            },
            {
                label: "Schweißen",
                value: "Schweißen",
            },
            {
                label: "Löten",
                value: "Löten",
            },
            {
                label: "Kleben",
                value: "Kleben",
            },
        ],
    },
    {
        oberKatLabel: "Materialien/ Werkstoffe",
        backendColor: "#ccc",
        color: "black",
        unterKat: [
            {
                label: "Smarte Materialien",
                value: "Smarte Materialien",
            },
            {
                label: "Formgedächtnislegierungen",
                value: "Formgedächtnislegierungen",
            },
            {
                label: "Eisen",
                value: "Eisen",
            },
            {
                label: "Edelstahl",
                value: "Edelstahl",
            },
            {
                label: "Aluminium",
                value: "Aluminium",
            },
            {
                label: "Kupfer",
                value: "Kupfer",
            },
            {
                label: "Blei",
                value: "Blei",
            },
            {
                label: "Zinn",
                value: "Zinn",
            },
            {
                label: "Nickel",
                value: "Nickel",
            },
            {
                label: "Titan",
                value: "Titan",
            },
            {
                label: "Legierungen",
                value: "Legierungen",
            },
            {
                label: "Chrom",
                value: "Chrom",
            },
            {
                label: "Verbundmaterialien",
                value: "Verbundmaterialien",
            },
            {
                label: "Kunststoffe",
                value: "Kunststoffe",
            },
        ],
    },
];

export const interesse = [
    {
        label: "Unterstützung bei der Umsetzung",
        value: "Unterstützung bei der Umsetzung",
    },
    {
        label: "Strategisches Nachhaltigkeitsmanagement",
        value: "Strategisches Nachhaltigkeitsmanagement",
    },
    { label: "Zirkuläre Wirtschaft", value: "Zirkuläre Wirtschaft" },
    {
        label: "Regionale Materialbeschaffung",
        value: "Regionale Materialbeschaffung",
    },
    { label: "Rückholsysteme", value: "Rückholsysteme" },
    {
        label: "Geschäftsmodellentwicklung",
        value: "Geschäftsmodellentwicklung",
    },
    { label: "Werkstofftechnik", value: "Werkstofftechnik" },
    { label: "Prozessoptimierung", value: "Prozessoptimierung" },
    { label: "Fertigungstechnologien", value: "Fertigungstechnologien" },
    { label: "Produktdesign", value: "Produktdesign" },
    { label: "Materialien", value: "Materialien" },
    {
        label: "rechtliche Fragestellungen",
        value: "rechtliche Fragestellungen",
    },
    { label: "Nachhaltigkeitsbericht", value: "Nachhaltigkeitsbericht" },
    { label: "CO₂ Bilanzierung", value: "CO₂ Bilanzierung" },
    { label: "Verpackungsgesetz", value: "Verpackungsgesetz" },
    { label: "Lieferkettengesetz", value: "Lieferkettengesetz" },
    { label: "Energieeffizienz", value: "Energieeffizienz" },
    {
        label: "Fach- und Führungskräfteentwicklung",
        value: "Fach- und Führungskräfteentwicklung",
    },
    { label: "Personalbeschaffung", value: "Personalbeschaffung" },
    { label: "Unternehmensnachfolge", value: "Unternehmensnachfolge" },
    { label: "Innovationsmanagement", value: "Innovationsmanagement" },
    { label: "Agile Methoden", value: "Agile Methoden" },
    { label: "Arbeit 4.0 ", value: "Arbeit 4.0 " },
    { label: "Wissensmanagement", value: "Wissensmanagement" },
    { label: "Netzwerken", value: "Netzwerken" },
];
